<template>
  <VDialogV3
    position="right"
    width="600px"
    title="Отправить на e-mail"
    :loading="transportOrder === null"
    @submit="sendMail"
  >
    <SWMailingList
      :receivers="localReceivers"
      @update="updateReceivers"
    />
  </VDialogV3>
</template>

<script lang="ts">

import type TransportOrder    from "@/domains/TransportOrders/TransportOrder";

import SWPortalTasksService   from "@/domains/SWPortalTask/SWPortalTasksService"
import TransportOrdersService from "@/domains/TransportOrders/TransportOrdersService";

import SWMailingList        from '@/domains/TransportOrders/components/SWMailingListCreateDialog/SWMailingList';

export default defineComponent({
	name:       'SWMailingListCreateDialog',
	components: { SWMailingList },

  props: {
    transportOrder: {
      type: Object as PropType<TransportOrder>,
      required: true,
    },
  },

  emits: ['close'],

  setup() {
    return {
      SWPortalTasksService,
    }
  },

  data() {
    return {
      localReceivers: SWPortalTasksService.getReceivers(),
      isSending:      false,
    };
  },

  methods: {
    async sendMail(): Promise<void> {
      this.isSending = true;
      try {
        const isSent = await TransportOrdersService.sendNotification(
          this.transportOrder.id,
          this.localReceivers.map(employee => ({ id: employee.id })),
        );

        if (isSent) {
          this.$emit('close');
        }
      } finally {
        this.isSending = false;
      }
    },

    updateReceivers(receivers: any[]): void {
      this.localReceivers = receivers;
    },
  },
});
</script>
